import React, { Component } from 'react';
import ModuleContainer from '../../../components/ModuleContainer';
import ViewHeader from '../../../components/ViewHeader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { NOTIF_SUCCESS, SECONDARY, NO, YES, SUCCESS_BUTTON, MOBILE_NOTIFICATION_TITLE, SEND_MOBILE_NOTIFICATION } from '../../../../utils/constants';
import { CONFIRM_SEND, SEND_PUSH_NOTIF_MESSAGE } from '../../../../utils/messages';
import { announcementOperations } from '../state';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { SideNotification } from '../../../../utils/common';

class MobileNotification extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            activePage: 1,
            totalPages: 0,
            showConfirmationModal: false,
            popupList: [],
            notificationTitle: '',
            notificationBody: ''
        }

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleBodyChange = this.handleBodyChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
    }

    cancelSend = () => {
        this.setState({
            showConfirmationModal: !this.state.showConfirmationModal
        })
    }

    handleTitleChange(event) {
        this.setState({ notificationTitle: event.target.value });
        event.preventDefault();
    }

    handleBodyChange(event) {
        this.setState({ notificationBody: event.target.value });
        event.preventDefault();
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.sendPushNotif(this.state.notificationTitle, this.state.notificationBody).then((result) => {
            this.setState({
                showConfirmationModal: !this.state.showConfirmationModal,
                notificationTitle: '',
                notificationBody: ''
            });
            SideNotification(NOTIF_SUCCESS, "Push Notification Sent.");
        }).catch((error) => console.log(error));
    }

    confirmSend = (event) => {
        this.setState({ showConfirmationModal: !this.state.showConfirmationModal })
        event.preventDefault();
    }


    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={MOBILE_NOTIFICATION_TITLE}
                />

                <form onSubmit={this.confirmSend}>
                    <label style={{ fontWeight: "bold", padding: "10px", fontSize: "20px" }}>
                        Title:
                        <br />
                        <input type="text"
                            name="title"
                            value={this.state.notificationTitle}
                            placeholder="SHS-ADC Alumni Association"
                            onChange={this.handleTitleChange}
                            style={{
                                width: "500px",
                                borderRadius: "5px"
                            }}
                        />
                    </label>
                    <br />
                    <label style={{ fontWeight: "bold", padding: "10px", fontSize: "20px" }}>
                        Body:
                        <br />
                        <textarea
                            name="body"
                            value={this.state.notificationBody}
                            placeholder="Push Notification Message..."
                            onChange={this.handleBodyChange}
                            style={{
                                width: "500px",
                                height: "500px",
                                borderRadius: "5px"
                            }}
                        />
                    </label>
                    <br />
                    <input type="submit"
                        value={SEND_MOBILE_NOTIFICATION}
                        style={{
                            margin: "10px",
                            padding: "10px",
                            fontSize: "20px",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            backgroundColor: "#5cb85c",
                            color: "#f7f7f7",
                            borderWidth: 0
                        }}
                    />
                </form>

                <ConfirmationModal
                    show={this.state.showConfirmationModal}
                    toggleModal={this.cancelSend}
                    title={CONFIRM_SEND}
                    message={SEND_PUSH_NOTIF_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.cancelSend, variant: SECONDARY },
                        { label: YES, onClick: this.handleSubmit, variant: SUCCESS_BUTTON }
                    ]}
                />

            </ModuleContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        popupList: state.announcements.popupList,
        popupTableHeaders: state.announcements.popupTable.tableHeaders,
        popupTableColumns: state.announcements.popupTable.tableColumns
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        sendPushNotif: announcementOperations.sendPushNotif
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(MobileNotification);
